import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetRequirement implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public active: boolean = null,
    public parent: SOGetRequirement = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetRequirement(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'active' in params ? params.active : null,
      'parent' in params ? params.parent : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
